import { AccountDepartment } from 'src/app/types/AccountDepartment';
import { State } from 'src/app/types/States';
import {
  OnboardingBusinessDetail,
  OnboardingQueueItem,
  SubmitIdentityVerificationQueryDocumentRequest,
  SubmitIdentityVerificationQueryDocumentResponse,
} from '../../pages/admin/admin-kyb-verifications/admin.types';
import { AuthorizedOwner } from '../../types/AuthorizedOwner';
import { Business } from '../../types/Business';
import { Country } from '../../types/Country';
import { InviteBusinessRequest } from '../../types/InviteBusinessRequest';
import { AdditionalInfoRequest } from '../../types/requests/AdditionalInfoRequest';
import { BankAccountDetailsInfoRequest } from '../../types/requests/BankAccountDetailsInfoRequest';
import { BusinessResponsibilitiesRequest } from '../../types/requests/BusinessResponsibilitiesRequest';
import { BusinessSearchRequest } from '../../types/requests/BusinessSearchRequest';
import { CreateBusinessRequest } from '../../types/requests/CreateBusinessRequest';
import { BusinessOnboardingResponse } from '../../types/responses/BusinessOnboardingResponse';

export abstract class IBusinessService {
  abstract getCountries(): Promise<Country[]>;
  abstract getClientCountries(): Promise<Country[]>;
  abstract getStates(): Promise<State[]>;
  // Search for business invitation
  abstract findBusinesses(request: BusinessSearchRequest): Promise<Business[]>;
  abstract getDataPostFirstStep(
    businessType: string,
    countryCode: string,
  ): Promise<BusinessOnboardingResponse>;
  abstract submitBusinessDetails(
    request: CreateBusinessRequest,
    verificationId: string,
  ): Promise<BusinessOnboardingResponse>;
  abstract submitAuthorizedOwners(
    owner: AuthorizedOwner[],
    verificationId: string,
  ): Promise<BusinessOnboardingResponse>;
  abstract updateBusinessResponsibilities(
    request: BusinessResponsibilitiesRequest,
    verificationId: string,
  ): Promise<BusinessOnboardingResponse>;
  abstract addAdditionalInfo(
    request: AdditionalInfoRequest,
    verificationId: string,
  ): Promise<BusinessOnboardingResponse>;

  abstract getPurposeCodes(customerId: string): Promise<{
    success: boolean;
    data: any[];
    error: string;
  }>;

  abstract addBankAccountDetails(
    request: BankAccountDetailsInfoRequest,
    verificationId: string,
  ): Promise<BusinessOnboardingResponse>;

  abstract submitAndVerify(
    verificationId: string,
  ): Promise<BusinessOnboardingResponse>;
  abstract inviteBusiness(request: InviteBusinessRequest): Promise<boolean>;
  abstract updateBusiness(
    body: AccountDepartment,
    id: string,
  ): Promise<boolean>;

  abstract checkIfUserBecameActive(
    customerId: string,
    selectedCountryCode: string,
  ): Promise<Boolean>;

  abstract getIdentityVerifications(): Promise<OnboardingQueueItem[]>;

  abstract getIdentityVerificationDetail(
    identityVerificationId: string,
  ): Promise<OnboardingBusinessDetail | null>;

  abstract submitIdentityVerificationQueryDocument(
    request: SubmitIdentityVerificationQueryDocumentRequest,
  ): Promise<SubmitIdentityVerificationQueryDocumentResponse>;
}
